
// CommonAction type for State clearing

const CLEAR_STATE = 'CLEAR_STATE';
const CLEAR_SSAP_STATE = 'CLEAR_SSAP_STATE';

export const commonActionTypes = {
    CLEAR_STATE,
    CLEAR_SSAP_STATE
};


// ActivePage action types

const CHANGE_PAGE = 'CHANGE_PAGE';

export const activePageActionTypes = {
    CHANGE_PAGE,
    CLEAR_SSAP_STATE
};


// Adjusted flow action types

const ADJUST_FLOW = 'ADJUST_FLOW';

export const adjustedFlowActionTypes = {
    ADJUST_FLOW,
    CLEAR_SSAP_STATE
};

// "Black hole" action types

const SET_CASE_NUMBER = 'SET_CASE_NUMBER';

export const blackHoleActionTypes = {
    SET_CASE_NUMBER,
    CLEAR_STATE
};


// Blood relations action types

const SET_RELATIONS = 'SET_RELATIONS';
const SET_RELATIONS_WHOLE_LIST = 'SET_RELATIONS_WHOLE_LIST';

export const bloodRelationshipActionTypes = {
    SET_RELATIONS,
    SET_RELATIONS_WHOLE_LIST,
    CLEAR_SSAP_STATE
};


// Console action types

const SWITCH_CONSOLE_MODE = 'SWITCH_CONSOLE_MODE';

export const consoleActionTypes = {
    SWITCH_CONSOLE_MODE,
    CLEAR_SSAP_STATE
};


// Counties action types

const SET_COUNTIES = 'SET_COUNTIES';
const SET_COUNTY_FOUND_BY_STATE_AND_ZIPCODE = 'SET_COUNTY_FOUND_BY_STATE_AND_ZIPCODE';

export const countiesActionTypes = {
    SET_COUNTIES,
    SET_COUNTY_FOUND_BY_STATE_AND_ZIPCODE,
    CLEAR_SSAP_STATE
};


// Countries action types

const SET_COUNTRIES = 'SET_COUNTRIES';

export const countriesActionTypes = {
    SET_COUNTRIES,
    CLEAR_SSAP_STATE
};


// Data (JSON) action types

const CHANGE_DATA = 'CHANGE_DATA';
const SET_DATA = 'SET_DATA';
const SET_SESSION_INITIAL_DATA = 'SET_SESSION_INITIAL_DATA';
const UPDATE_SSNS = 'UPDATE_SSNS';
const UPDATE_IMI = 'UPDATE_IMI';

export const dataActionTypes = {
    CHANGE_DATA,
    SET_DATA,
    SET_SESSION_INITIAL_DATA,
    UPDATE_SSNS,
    UPDATE_IMI,
    CLEAR_SSAP_STATE
};

const CACHE_SSNS = 'CACHE_SSNS';
const CACHE_PREVIOUS_SSNS = 'CACHE_PREVIOUS_SSNS';
const REMOVE_CACHED_DATA = 'REMOVE_CACHED_DATA';
const UPDATE_CACHED_SSN = 'UPDATE_CACHED_SSN';
const CACHE_IMI = 'CACHE_IMI';
const CACHE_PREVIOUS_IMI = 'CACHE_PREVIOUS_IMI';
const UPDATE_CACHED_IMI = 'UPDATE_CACHED_IMI';

export const cacheActionTypes = {
    CACHE_SSNS,
    CACHE_PREVIOUS_SSNS,
    REMOVE_CACHED_DATA,
    UPDATE_CACHED_SSN,
    CACHE_IMI,
    CACHE_PREVIOUS_IMI,
    UPDATE_CACHED_IMI,
    CLEAR_SSAP_STATE
};

// Data structure action types

const SET_DATA_STRUCTURE = 'SET_DATA_STRUCTURE';

export const dataStructureActionTypes = {
    SET_DATA_STRUCTURE,
    CLEAR_SSAP_STATE
};


// Data structure action types

const SET_HYPER_REVIEW = 'SET_HYPER_REVIEW';

export const hyperReviewActionTypes = {
    SET_HYPER_REVIEW,
    CLEAR_SSAP_STATE
};


// Disabled UI action types

const UPDATE_DISABLED_UI = 'UPDATE_DISABLED_UI';
const CLEAR_DISABLED_UI = 'CLEAR_DISABLED_UI';

export const disabledUiActionTypes = {
    CLEAR_DISABLED_UI,
    UPDATE_DISABLED_UI,
    CLEAR_SSAP_STATE
};



// Member Affordability (JSON) action types

const SET_MEMBER_AFFORDABILITY = 'SET_MEMBER_AFFORDABILITY';

export const memberAffordabilityTypes = {
    SET_MEMBER_AFFORDABILITY,
    CLEAR_SSAP_STATE
};


// Exception action types

const SET_EXCEPTION = 'SET_EXCEPTION';
const REMOVE_EXCEPTION = 'REMOVE_EXCEPTION';
const UPDATE_EXCEPTION = 'UPDATE_EXCEPTION';

export const exceptionActionTypes = {
    SET_EXCEPTION,
    REMOVE_EXCEPTION,
    UPDATE_EXCEPTION,
    CLEAR_SSAP_STATE
};


// Form action types

const CHANGE_INPUT_STATUS = 'CHANGE_INPUT_STATUS';
const CLEAR_SUBMISSION = 'CLEAR_SUBMISSION';
const MAKE_SNAPSHOT = 'MAKE_SNAPSHOT';
const REGISTER_FORM = 'REGISTER_FORM';
const REGISTER_INPUT = 'REGISTER_INPUT';
const RE_REGISTER_INPUT = 'RE_REGISTER_INPUT';
const REMOVE_FORM = 'REMOVE_FORM';
const REMOVE_INPUT = 'REMOVE_INPUT';
const SUBMIT_FORM = 'SUBMIT_FORM';
const VALIDATE_FORM = 'VALIDATE_FORM';

export const formActionTypes = {
    CHANGE_INPUT_STATUS,
    CLEAR_SUBMISSION,
    MAKE_SNAPSHOT,
    REGISTER_INPUT,
    REGISTER_FORM,
    RE_REGISTER_INPUT,
    REMOVE_FORM,
    REMOVE_INPUT,
    SUBMIT_FORM,
    VALIDATE_FORM,
    CLEAR_SSAP_STATE
};


// Flow action types

const SET_FLOW = 'SET_FLOW';

export const flowActionTypes = {
    SET_FLOW,
    CLEAR_SSAP_STATE
};


// Header Data (JSON) action types

const SET_ENVIRONMENTS = 'SET_ENVIRONMENTS';

export const headerFooterLinkTypes = {
    SET_ENVIRONMENTS,
    CLEAR_STATE
};


// Language action types

const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

export const languageActionTypes = {
    CHANGE_LANGUAGE,
    CLEAR_STATE
};

// Link from other pages

const SET_LINK_FROM = 'ssap/LINK_FROM';

export const linkFromTypes = {
    SET_LINK_FROM
};

// Methods action types

const SET_METHODS = 'SET_METHODS';
const CLEAR_METHODS = 'CLEAR_METHODS';

export const methodsActionTypes = {
    SET_METHODS,
    CLEAR_METHODS,
    CLEAR_SSAP_STATE
};


// Messages action types

const SET_MESSAGES = 'SET_MESSAGES';

export const messagesActionTypes = {
    SET_MESSAGES,
    CLEAR_STATE
};


// Scroll action types

const DEFINE_ELEMENT_FOR_SCROLLING = 'DEFINE_ELEMENT_FOR_SCROLLING';
const CLEAR_ELEMENT_FOR_SCROLLING = 'CLEAR_ELEMENT_FOR_SCROLLING';

export const scrollActionTypes = {
    DEFINE_ELEMENT_FOR_SCROLLING,
    CLEAR_ELEMENT_FOR_SCROLLING,
    CLEAR_SSAP_STATE
};


// Spinner action types

const START_SPINNER = 'START_SPINNER';
const STOP_SPINNER = 'STOP_SPINNER';

export const spinnerActionTypes = {
    START_SPINNER,
    STOP_SPINNER,
    CLEAR_STATE
};

// Launch SSAP action types
const SET_SSAP_IN_REVIEW_MODE = 'SET_SSAP_IN_REVIEW_MODE';
const SET_SSAP_LAUNCH = 'SET_SSAP_LAUNCH';
const CUSTOM_MIDDLEWARE_FLOW_ADJUSTMENT_COMPLETED = 'CUSTOM_MIDDLEWARE_FLOW_ADJUSTMENT_COMPLETED';

export const launchActionTypes = {
    SET_SSAP_IN_REVIEW_MODE,
    SET_SSAP_LAUNCH,
    CUSTOM_MIDDLEWARE_FLOW_ADJUSTMENT_COMPLETED,
    CLEAR_SSAP_STATE
};

// Summary action types

const CLEAR_SUMMARY_VALUES = 'CLEAR_SUMMARY_VALUES';
const SET_SUMMARY_CRASHED = 'SET_SUMMARY_CRASHED';
const SHOW_EXTRA_FINAL_SUMMARY = 'SHOW_EXTRA_FINAL_SUMMARY';
const TOGGLE_UPDATED_VALUES_VISIBILITY = 'TOGGLE_UPDATED_VALUES_VISIBILITY';

export const summaryActionTypes = {
    CLEAR_SUMMARY_VALUES,
    SET_SUMMARY_CRASHED,
    SHOW_EXTRA_FINAL_SUMMARY,
    TOGGLE_UPDATED_VALUES_VISIBILITY,
    CLEAR_SSAP_STATE
};

// Previous SSAP Data types

const CLEAR_PREVIOUS_DATA = 'CLEAR_PREVIOUS_DATA';
const SET_PREVIOUS_DATA = 'SET_PREVIOUS_DATA';
const UPDATE_PREVIOUS_DATA_SSNS = 'UPDATE_PREVIOUS_DATA_SSNS';
const UPDATE_PREVIOUS_DATA_IMI = 'UPDATE_PREVIOUS_DATA_IMI';

export const previousDataActionTypes = {
    CLEAR_PREVIOUS_DATA,
    CLEAR_SSAP_STATE,
    SET_PREVIOUS_DATA,
    UPDATE_PREVIOUS_DATA_SSNS,
    UPDATE_PREVIOUS_DATA_IMI
};


// Tribe action types

const SET_TRIBES = 'SET_TRIBES';
const CLEAR_TRIBES = 'CLEAR_TRIBES';

export const tribesActionTypes = {
    SET_TRIBES,
    CLEAR_TRIBES,
    CLEAR_SSAP_STATE
};


// Routes directions action types

const CHANGE_DIRECTION = 'CHANGE_DIRECTION';

export const switchDirectionsActionTypes = {
    CHANGE_DIRECTION,
    CLEAR_SSAP_STATE
};

// SSAP settings action types

const SET_SSAP_SETTINGS = 'SET_SSAP_SETTINGS';

export const settingsActionTypes = {
    SET_SSAP_SETTINGS,
    CLEAR_SSAP_STATE
};

// SSAP enrollments action types

const SET_BULK_ENROLLMENTS = 'SET_BULK_ENROLLMENTS';
const SET_ENROLLMENT = 'SET_ENROLLMENT';
const SET_PROGRESS = 'SET_PROGRESS';

export const enrollmentsActionTypes = {
    SET_ENROLLMENT,
    SET_BULK_ENROLLMENTS,
    SET_PROGRESS,
    CLEAR_SSAP_STATE
};


// ssapSagaActionTypes

const BLOOD_RELATIONSHIPS_CHECK = 'BLOOD_RELATIONSHIPS_CHECK';
const BLOOD_RELATIONSHIPS_CHECK_FAILURE = 'BLOOD_RELATIONSHIPS_CHECK_FAILURE';
const BLOOD_RELATIONSHIPS_CHECK_SUCCESS = 'BLOOD_RELATIONSHIPS_CHECK_SUCCESS';
const FETCH_AFFORDABILITY = 'FETCH_AFFORDABILITY';
const FETCH_AFFORDABILITY_FAILURE = 'FETCH_AFFORDABILITY_FAILURE';
const FETCH_AFFORDABILITY_SUCCESS = 'FETCH_AFFORDABILITY_SUCCESS';
const FETCH_ALL_BLOOD_RELATIONSHIPS = 'FETCH_ALL_BLOOD_RELATIONSHIPS';
const FETCH_ALL_BLOOD_RELATIONSHIPS_FAILURE = 'FETCH_ALL_BLOOD_RELATIONSHIPS_FAILURE';
const FETCH_ALL_BLOOD_RELATIONSHIPS_SUCCESS = 'FETCH_ALL_BLOOD_RELATIONSHIPS_SUCCESS';
const FETCH_COUNTIES_FOR_ZIPCODE = 'FETCH_COUNTIES_FOR_ZIPCODE';
const FETCH_COUNTIES_FOR_ZIPCODE_FAILURE = 'FETCH_COUNTIES_FOR_ZIPCODE_FAILURE';
const FETCH_COUNTIES_FOR_ZIPCODE_SUCCESS = 'FETCH_COUNTIES_FOR_ZIPCODE_SUCCESS';
const FETCH_COUNTRIES = 'FETCH_COUNTRIES';
const FETCH_COUNTRIES_FAILURE = 'FETCH_COUNTRIES_FAILURE';
const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';
const FETCH_ENROLLMENTS = 'FETCH_ENROLLMENTS';
const FETCH_ENROLLMENTS_FAILURE = 'FETCH_ENROLLMENTS_FAILURE';
const FETCH_ENROLLMENTS_SUCCESS = 'FETCH_ENROLLMENTS_SUCCESS';
const FETCH_SSAP_DATA = 'FETCH_SSAP_DATA';
const FETCH_SSAP_DATA_FAILURE = 'FETCH_SSAP_DATA_FAILURE';
const FETCH_SSAP_DATA_SILENT_FAILURE = 'FETCH_SSAP_DATA_SILENT_FAILURE';
const FETCH_SSAP_DATA_SUCCESS = 'FETCH_SSAP_DATA_SUCCESS';
const FETCH_SSAP_PREVIOUS_DATA = 'FETCH_SSAP_PREVIOUS_DATA';
const FETCH_SSAP_PREVIOUS_DATA_FAILURE = 'FETCH_SSAP_PREVIOUS_DATA_FAILURE';
const FETCH_SSAP_PREVIOUS_DATA_SUCCESS = 'FETCH_SSAP_PREVIOUS_DATA_SUCCESS';
const FETCH_TRIBES = 'FETCH_TRIBES';
const FETCH_TRIBES_FAILURE = 'FETCH_TRIBES_FAILURE';
const FETCH_TRIBES_SUCCESS = 'FETCH_TRIBES_SUCCESS';
const RECEIVE_SSNS = 'RECEIVE_SSNS';
const RECEIVE_IMMIGRATION_INFO = 'RECEIVE_IMMIGRATION_INFO';
const RECEIVE_IMI_FAILURE = 'RECEIVE_IMI_FAILURE';
const RECEIVE_IMI_START = 'RECEIVE_IMI_START';
const RECEIVE_IMI_SUCCESS = 'RECEIVE_IMI_SUCCESS';
const RECEIVE_SSNS_FAILURE = 'RECEIVE_SSNS_FAILURE';
const RECEIVE_SSNS_START = 'RECEIVE_SSNS_START';
const RECEIVE_SSNS_SUCCESS = 'RECEIVE_SSNS_SUCCESS';
const SEND_SUMMARY_TO_INBOX = 'SEND_SUMMARY_TO_INBOX';
const SAVE_SSAP = 'SAVE_SSAP';
const SAVE_SSAP_FAILURE = 'SAVE_SSAP_FAILURE';
const SAVE_SSAP_SUCCESS = 'SAVE_SSAP_SUCCESS';
const SUBMIT_SSAP = 'SUBMIT_SSAP';
const SUBMIT_SSAP_FAILURE = 'SUBMIT_SSAP_FAILURE';
const SUBMIT_SSAP_SUCCESS = 'SUBMIT_SSAP_SUCCESS';
const VALIDATE_ADDRESS = 'VALIDATE_ADDRESS';
const VALIDATE_ADDRESS_FAILURE = 'VALIDATE_ADDRESS_FAILURE';
const VALIDATE_ADDRESS_SUCCESS = 'VALIDATE_ADDRESS_SUCCESS';

export const ssapSagaActionTypes = {
    BLOOD_RELATIONSHIPS_CHECK,
    BLOOD_RELATIONSHIPS_CHECK_FAILURE,
    BLOOD_RELATIONSHIPS_CHECK_SUCCESS,
    FETCH_AFFORDABILITY,
    FETCH_AFFORDABILITY_FAILURE,
    FETCH_AFFORDABILITY_SUCCESS,
    FETCH_ALL_BLOOD_RELATIONSHIPS,
    FETCH_ALL_BLOOD_RELATIONSHIPS_FAILURE,
    FETCH_ALL_BLOOD_RELATIONSHIPS_SUCCESS,
    FETCH_COUNTIES_FOR_ZIPCODE,
    FETCH_COUNTIES_FOR_ZIPCODE_FAILURE,
    FETCH_COUNTIES_FOR_ZIPCODE_SUCCESS,
    FETCH_COUNTRIES,
    FETCH_COUNTRIES_FAILURE,
    FETCH_COUNTRIES_SUCCESS,
    FETCH_ENROLLMENTS,
    FETCH_ENROLLMENTS_FAILURE,
    FETCH_ENROLLMENTS_SUCCESS,
    FETCH_SSAP_DATA,
    FETCH_SSAP_DATA_FAILURE,
    FETCH_SSAP_DATA_SILENT_FAILURE,
    FETCH_SSAP_DATA_SUCCESS,
    FETCH_SSAP_PREVIOUS_DATA,
    FETCH_SSAP_PREVIOUS_DATA_FAILURE,
    FETCH_SSAP_PREVIOUS_DATA_SUCCESS,
    FETCH_TRIBES,
    FETCH_TRIBES_FAILURE,
    FETCH_TRIBES_SUCCESS,
    RECEIVE_SSNS,
    RECEIVE_IMMIGRATION_INFO,
    RECEIVE_IMI_FAILURE,
    RECEIVE_IMI_START,
    RECEIVE_IMI_SUCCESS,
    RECEIVE_SSNS_FAILURE,
    RECEIVE_SSNS_START,
    RECEIVE_SSNS_SUCCESS,
    SEND_SUMMARY_TO_INBOX,
    SAVE_SSAP,
    SAVE_SSAP_FAILURE,
    SAVE_SSAP_SUCCESS,
    SUBMIT_SSAP,
    SUBMIT_SSAP_FAILURE,
    SUBMIT_SSAP_SUCCESS,
    VALIDATE_ADDRESS,
    VALIDATE_ADDRESS_FAILURE,
    VALIDATE_ADDRESS_SUCCESS
};
